import * as React from "react";
import { Typography, MenuItem, makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: any) => {
  const {
    palette: {
      secondary: { main }
    }
  } = theme;

  return {
    root: {
      "& > .icon-feedback": {
        fontSize: "2rem"
      },
      "& > .icon-people": {
        fontSize: "2.2rem"
      },
      '& > [class*="icon-"]': {
        marginRight: 12
      },
      "&:hover": {
        backgroundColor: "transparent !important",
        color: main
      },
      borderRadius: "0 100px 100px 0",
      color: "#646464",
      fontSize: "1.5rem",
      fontWeight: 600,
      marginTop: 16,
      textDecoration: "none"
    },
    disabledMenuItem: {
      "& > .icon-feedback": {
        fontSize: "2rem"
      },
      "& > .icon-people": {
        fontSize: "2.2rem"
      },
      '& > [class*="icon-"]': {
        marginRight: 12
      },
      padding: "6px 6px 6px 20px",
      borderRadius: "0 100px 100px 0",
      color: "#646464",
      fontSize: "1.5rem",
      fontWeight: 600,
      marginTop: 16,
      textDecoration: "none"
    },
    selected: {
      "&:hover": {
        backgroundColor: `#fee8d8 !important`
      },
      backgroundColor: `#fee8d8 !important`,
      color: "#fd6500"
    }
  };
});

interface IProps {
  children: React.ReactNode;
  selected: boolean;
  to?: string;
  onClick?: () => void;
  dataTestId?: string;
  disabled?: boolean;
  name?: string;
}

const SideMenuItem = ({ selected, to, children, onClick, dataTestId, disabled, name = "" }: IProps) => {
  const classes = useStyles();
  const MenuLink = to ? React.forwardRef((props: any, ref: any) => <Link to={to} ref={ref} {...props} />) : "div";
  return !disabled ? (
    <MenuItem
      disableGutters
      className={classes.root}
      classes={{ selected: classes.selected }}
      selected={selected}
      component={MenuLink}
      onClick={onClick}
      data-qa-selector={dataTestId}
    >
      {children}
    </MenuItem>
  ) : (
    <Typography className={classes.disabledMenuItem}>{name}</Typography>
  );
};

export default React.memo(SideMenuItem);
